import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';

export default function ContainerKoersel() {
  return (
    <>
      <SEO
        title="Kørsel af containere & toldklarering af gods | Fastlane ApS"
        description="Import spedition af container fra 3. land. Komplet koordinering med rederi, told & skat, havn og vognmand på chassis, med sidelastere (besima) eller trailer."
        canonicalUrl="https://fastlane.dk/koersel-af-importcontainere"
      />

      <PageHeader
        title="Kørsel af containere & toldklarering af gods"
        subtitle="Sikker og rettidig importspedition af containere fra 3. land og hele verden."
        breadcrumbs={[
          { label: 'Ydelser', path: '/godstransport-i-europa' },
          { label: 'Containerkørsel & Toldklarering' }
        ]}
      />

      <div className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          {/* Main content */}
          <div className="space-y-4 text-slate-700 leading-relaxed text-base sm:text-lg">
            <h2 className="text-2xl font-bold text-[#0f2b48]">
              Import spedition af container fra 3. land
            </h2>
            <p>
              For mange importører af containere kan det være en udfordring, at få kommunikeret til Rederi – Linieagent – Told & Skat – Havnemyndigheder, modtager og vognmand rettidigt.
            </p>
            <p>
              Vi tilbyder derfor en totalløsning, hvor importøren blot skal sende os kopi af alle dokumenter på deres forsendelse, hvorefter vi sørger for at koordinere resten af processen til godset er leveret på aftalt sted.
            </p>

            <ul className="space-y-2 text-sm sm:text-base text-slate-700 pt-2">
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-check text-sky-600" aria-hidden="true" />
                <span>rettidig koordinering/kommunikation med involverede parter</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-check text-sky-600" aria-hidden="true" />
                <span>indfortoldning</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-check text-sky-600" aria-hidden="true" />
                <span>betaling af havnegebyrer, THC m.m.</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-check text-sky-600" aria-hidden="true" />
                <span>afstemning m.h.t. leveringstid</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-check text-sky-600" aria-hidden="true" />
                <span>slutlevering med faste vognmænd på enten chassis, med sidelastere (besima) eller trailer i hele Danmark</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-check text-sky-600" aria-hidden="true" />
                <span>ved 3. parts intervention f.eks. toldkontrol tager vi dialogen og reviderer planerne med information til relevante parter</span>
              </li>
            </ul>
          </div>

          {/* Hvorfor outsource */}
          <div className="bg-slate-50 p-6 sm:p-8 rounded-2xl border border-slate-200/90 space-y-4">
            <h3 className="text-xl font-bold text-[#0f2b48]">
              Hvorfor er det en god idé at outsource netop kørsel af container og de relaterede opgaver til os?
            </h3>
            <p className="text-sm text-slate-700 leading-relaxed">
              Vi kender rumlen og derfor kan vi sørge for, at de enkelte delopgaver bliver gjort i den rigtige rækkefølge og rettidigt. Unødvendige omkostninger forebygges så vidt muligt og kunden sparer tid på kommunikation.
            </p>
            <p className="text-sm text-slate-700 leading-relaxed font-semibold">
              Sluttelig får kunden en samlet afregning med kopi af fortoldning vedhæftet og således et godt overblik.
            </p>

            <div className="pt-4 border-t border-slate-200 flex flex-col sm:flex-row sm:flex-wrap gap-4 sm:items-center">
              <span className="text-sm text-slate-600">
                Ønsker du en pris på de samlede modtageromkostningerne ved import af gods i container:
              </span>
              <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
                <Link
                  to="/fragtrater"
                  className="w-full sm:w-auto inline-flex items-center justify-center px-5 py-2.5 rounded-lg bg-[#b25d19] text-white text-sm font-semibold hover:bg-[#974d12] text-center"
                >
                  Send forespørgsel
                </Link>
                <a
                  href="tel:+4576121230"
                  className="w-full sm:w-auto inline-flex items-center justify-center px-5 py-2.5 rounded-lg bg-white border border-slate-300 text-slate-900 text-sm font-semibold hover:bg-slate-100 whitespace-nowrap text-center"
                >
                  +45 76 12 12 30
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
